// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer{
    height: 15rem;
    background-color: rgba(15, 15, 15, 0.8);
}

.footer-icon{
    width: 2em;
    height: 2em;
    font-size: 2.5em;
    background: radial-gradient(circle, rgba(0, 0, 0, 1) 30%, rgb(0 254 255) 100%);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,8EAA8E;AAClF","sourcesContent":[".footer{\n    height: 15rem;\n    background-color: rgba(15, 15, 15, 0.8);\n}\n\n.footer-icon{\n    width: 2em;\n    height: 2em;\n    font-size: 2.5em;\n    background: radial-gradient(circle, rgba(0, 0, 0, 1) 30%, rgb(0 254 255) 100%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
